<template>
    <div  class="pt-2">
        <v-row v-if="spielerListe.length > 0" :class="[{'mb-5': $vuetify.breakpoint.xsOnly}]">
            <v-col sm="8" cols="12" class="py-0">
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                              label="In der Ergebnistabelle suchen" :solo="$vuetify.breakpoint.smAndUp"
                              :outlined="$vuetify.breakpoint.xsOnly"
                              dense light class="mt-0 mb-5 white"
                              single-line hide-details >
                    <template v-slot:append>
                        <v-btn icon small class="pb-1">
                            <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
            <v-col sm="4" cols="12" class="py-0">
                <v-btn :color="$vuetify.breakpoint.smAndUp?'white':''" block
                       @click="downloadToExcelSheet()">
                    <v-icon color="primary" class="mr-3">mdi-cloud-download</v-icon>
                    Excel
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table v-if="searchStarted || spielerListe.length > 0" :headers="headers" :items="spielerListe" :search="search"
                      @current-items="getFiltered" mobile-breakpoint="1"
                      :class="[{'mt-2': $vuetify.breakpoint.smAndUp && spielerListe.length > 0}, 'elevation-2']"
                       hide-default-footer disable-pagination>
            <template v-slot:no-data><span class="primary--text font-weight-bold">
                Es gibt für diese Auswahl keine fehlenden ADE- oder DSV-Dokumente!</span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import EXCEL_DOWNLOAD from "../../services/downloads/excel/excelDownload";
    import TimeStamp from "../../services/timeStamp";

    export default {
        name: "search-spieler-missing-docs",
        computed: {
            searchResult(){ return this.$store.state.realtime.spielerSearchResult }
        },
        data: () => ({
            searchStarted: false,
            filteredItems: [],
            spielerListe: [],
            search: null,
            headers: [
                    {text: 'Verein', value: 'verein' },
                    {text: 'PassNr', value: 'passNr' },
                    {text: 'Nachname', value: 'nachname' },
                    {text: 'Vorname', value: 'vorname' },
                    {text: 'Status', value: 'status' },
                    {text: 'ADE', value: 'adeStatus' },
                    {text: 'DSV', value: 'dsvStatus' },
            ],
        }),
        created () {
            if ( this.searchResult.length > 0 ) {
                this.setItems();
            }
        },
        methods: {
            setItems(){
                this.searchResult.forEach( (item) => {
                    let itemTemp = {
                        verein: this.getVerein(item.search),
                        passNr: '',
                        nachname: item.nachname,
                        vorname: item.vorname,
                        status: item.status,
                        adeStatus: this.getStatusText(item.search.docs, 1),
                        dsvStatus: this.getStatusText(item.search.docs, 2),
                    };
                    itemTemp.passNr = this.getPassnummer(itemTemp.verein, item);
                    this.spielerListe.push(itemTemp)
                });
            },
            getStatusText(text, pos){
                return text.split('_')[pos] === '1' ? pos === 1 ? 'ADE fehlt' : 'DSV fehlt' : 'ok';
            },
            getVerein(itemSearch){
                let verein = '';
                if ( itemSearch.lastAktiv ) {
                    Object.keys(itemSearch.lastAktiv).forEach( (key) => {
                        if ( key.length > 2 ) { verein = key }
                    });
                }
                return verein
            },
            getPassnummer(verein, item){
                let until = '';
                let passNr = '';
                item.memberships.forEach( (membership) => {
                    if ( membership.lvVereinId === verein && membership.until > until ) {
                        until = membership.until;
                        passNr = membership.passNr;
                    }
                });
                return passNr;
            },
            getFiltered(items){
                this.filteredItems = items
            },
            downloadToExcelSheet(){
                const fileTimeStamp = TimeStamp.getFileTimeStamp();
                EXCEL_DOWNLOAD.exportJsonList(this.filteredItems, 'Fehlende Dokumente', fileTimeStamp);
            }
        },
        watch: {
            searchResult(){
                this.searchStarted = true;
                if ( this.searchResult.length > 0 ) {
                    this.setItems();
                } else {
                    this.spielerListe = [];
                }
            }
        }
    }
</script>

<style scoped>
</style>